(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["afz-gallery-loop"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('afz-gallery-loop')) {
    const warmingGalleries = new WeakSet();
    class AFZGalleryLoop extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.video.muted = true;
        this.video.defaultMuted = true;
        this.video.loop = true;
        this.video.controls = false;
        this.video.playsInline = true;
        this.video.setAttribute('muted', '');
        this.video.setAttribute('playsinline', '');
        this.video.removeAttribute('controls');
        this.slide = this.closest('slideshow-slide');
        this.visible = false;
        this.controller = new AbortController();
        this.sync = this.syncPlayback.bind(this);
        this.video.addEventListener('canplay', () => this.prepareGallery(), { signal: this.controller.signal });
        this.video.addEventListener('playing', () => this.prepareGallery(), { signal: this.controller.signal });
        this.observer = new IntersectionObserver(
          (entries) => {
            this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.5;
            this.sync();
          },
          { threshold: [0, 0.5, 1] }
        );
        this.observer.observe(this);
        requestAnimationFrame(() => this.prepareGallery());
        this.attributesObserver = new MutationObserver(this.sync);
        if (this.slide) {
          this.attributesObserver.observe(this.slide, {
            attributes: true,
            attributeFilter: ['aria-hidden', 'hidden'],
          });
        }
        document.addEventListener('visibilitychange', this.sync, { signal: this.controller.signal });
        window.addEventListener('pageshow', this.sync, { signal: this.controller.signal });
      }

      prepareGallery() {
        if (document.hidden || this.video.readyState < 3) return;
        const gallery = this.closest('slideshow-component');
        if (!gallery || warmingGalleries.has(gallery)) return;
        warmingGalleries.add(gallery);
        const videos = [...gallery.querySelectorAll('slideshow-slide afz-gallery-loop video')];
        const activeIndex = videos.indexOf(this.video);
        const queue = [...videos.slice(activeIndex + 1), ...videos.slice(0, activeIndex)];
        const signal = this.controller.signal;
        const worker = async () => {
          while (queue.length && !signal.aborted && gallery.isConnected) {
            const video = queue.shift();
            await this.bufferVideo(video, signal);
          }
        };
        void worker();
        void worker();
      }

      bufferVideo(video, signal) {
        return new Promise((resolve) => {
          let timer;
          const events = ['progress', 'canplaythrough', 'suspend'];
          const finished = () => {
            clearTimeout(timer);
            events.forEach((event) => video.removeEventListener(event, check));
            video.removeEventListener('error', finished);
            signal.removeEventListener('abort', finished);
            resolve();
          };
          const check = () => {
            if (!Number.isFinite(video.duration) || !video.buffered.length) return;
            if (video.buffered.start(0) < 0.1 && video.buffered.end(0) >= video.duration - 0.05) finished();
          };
          events.forEach((event) => video.addEventListener(event, check));
          video.addEventListener('error', finished, { once: true });
          signal.addEventListener('abort', finished, { once: true });
          timer = setTimeout(finished, 12000);
          if (video.getAttribute('preload') !== 'auto') {
            video.preload = 'auto';
            video.load();
          }
          check();
        });
      }

      syncPlayback() {
        const visibilityDriven = ['54984933998724', '54984934031492', '54984934064260', '54984934097028', '54984934129796'].includes(this.dataset.mediaId);
        const active = this.visible && !document.hidden && (visibilityDriven || this.slide?.getAttribute('aria-hidden') !== 'true');
        if (active) {
          this.video.muted = true;
          this.video.autoplay = true;
          this.video.preload = 'auto';
          this.prepareGallery();
          if (this.video.paused) {
            this.video.play().catch(() => {});
          }
        } else {
          this.video.autoplay = false;
          this.video.pause();
        }
      }

      disconnectedCallback() {
        this.video?.pause();
        this.observer?.disconnect();
        this.attributesObserver?.disconnect();
        this.controller?.abort();
      }
    }
    customElements.define('afz-gallery-loop', AFZGalleryLoop);
  }
  } catch(e) { console.error(e); }
})();

})();
